<template>
  <div class="content" v-if="route.name == 'Beranda'">
    <Beranda />
  </div>
  <div class="content" v-if="route.name == 'AksiLogin'">
    <AksiLogin />
  </div>
  <div class="content" v-if="route.name == 'Login'">
    <Login />
  </div>
  <div class="content" v-if="route.name == 'KontakKami'">
    <KontakKami />
  </div>
  <div class="content" v-if="route.name == 'MasukanSaran'">
    <MasukanSaran />
  </div>
  <div class="content" v-if="route.name == 'DaftarStatus'">
    <DaftarStatus />
  </div>
  <div class="content" v-if="route.name == 'DaftarProgramBudgeting'">
    <DaftarProgramBudgeting />
  </div>
  <div class="content" v-if="route.name == 'DaftarFinance'">
    <DaftarFinance />
  </div>
  <div class="content" v-if="route.name == 'DaftarPDOIOS'">
    <DaftarPDOIOS />
  </div>
  <div class="content" v-if="route.name == 'DaftarQuickStatus'">
    <DaftarQuickStatus />
  </div>
  <div class="content" v-if="route.name == 'DaftarAduan'">
    <DaftarAduan />
  </div>
  <div class="content" v-if="route.name == 'DaftarTimPelaksana'">
    <DaftarTimPelaksana />
  </div>
  <div class="content" v-if="route.name == 'DaftarAgenda'">
    <DaftarAgenda />
  </div>
  <div class="content" v-if="route.name == 'DaftarMonev'">
    <DaftarMonev />
  </div>
  <div class="content" v-if="route.name == 'Aduan'">
    <Aduan />
  </div>
  <div class="content" v-if="route.name == 'CariAduan'">
    <CariAduan />
  </div>
  <div class="content" v-if="route.name == 'DaftarKegiatan'">
    <DaftarKegiatan />
  </div>
  <div class="content" v-if="route.name == 'DaftarBerita'">
    <DaftarBerita />
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbum'">
    <DaftarAlbum />
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleri'">
    <DaftarGaleri />
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbumDokumen'">
    <DaftarAlbumDokumen />
  </div>
  <div class="content" v-if="route.name == 'DaftarAlbumDocumen'">
    <DaftarAlbumDocumen />
  </div>
  <div class="content" v-if="route.name == 'DaftarGaleriDokumen'">
    <DaftarGaleriDokumen />
  </div>
  <div class="content" v-if="route.name == 'Dashboard'">
    <Dashboard />
  </div>
  <div class="content" v-if="route.name == 'Slider'">
    <Slider />
  </div>
  <div class="content" v-if="route.name == 'ProsesSlider'">
    <ProsesSlider />
  </div>
  <div class="content" v-if="route.name == 'Kategori'">
    <Kategori />
  </div>
  <div class="content" v-if="route.name == 'ProsesKategori'">
    <ProsesKategori />
  </div>
  <div class="content" v-if="route.name == 'SubKategori'">
    <SubKategori />
  </div>
  <div class="content" v-if="route.name == 'ProsesSubKategori'">
    <ProsesSubKategori />
  </div>
  <div class="content" v-if="route.name == 'UnitKategori'">
    <UnitKategori />
  </div>
  <div class="content" v-if="route.name == 'ProsesUnitKategori'">
    <ProsesUnitKategori />
  </div>
  <div class="content" v-if="route.name == 'InfoBeranda'">
    <InfoBeranda />
  </div>
  <div class="content" v-if="route.name == 'ProsesInfoBeranda'">
    <ProsesInfoBeranda />
  </div>
  <div class="content" v-if="route.name == 'Konten'">
    <Konten />
  </div>
  <div class="content" v-if="route.name == 'ProsesKonten'">
    <ProsesKonten />
  </div>
  <div class="content" v-if="route.name == 'User'">
    <User />
  </div>
  <div class="content" v-if="route.name == 'ProsesUser'">
    <ProsesUser />
  </div>
  <div class="content" v-if="route.name == 'TimPelaksana'">
    <TimPelaksana />
  </div>
  <div class="content" v-if="route.name == 'ProsesTimPelaksana'">
    <ProsesTimPelaksana />
  </div>
  <div class="content" v-if="route.name == 'Inbox'">
    <Inbox />
  </div>
  <div class="content" v-if="route.name == 'ProsesInbox'">
    <ProsesInbox />
  </div>
  <div class="content" v-if="route.name == 'Kalendar'">
    <Kalendar />
  </div>
  <div class="content" v-if="route.name == 'ProsesKalendar'">
    <ProsesKalendar />
  </div>
  <div class="content" v-if="route.name == 'ViewKalendar'">
    <ViewKalendar />
  </div>
  <div class="content" v-if="route.name == 'Monev'">
    <Monev />
  </div>
  <div class="content" v-if="route.name == 'ProsesMonev'">
    <ProsesMonev />
  </div>
  <div class="content" v-if="route.name == 'ProsesPDOMonev'">
    <ProsesPDOMonev />
  </div>
  <div class="content" v-if="route.name == 'ProsesKurvaS'">
    <ProsesKurvaS />
  </div>
  <div class="content" v-if="route.name == 'KendalaTindakLanjut'">
    <KendalaTindakLanjut />
  </div>
  <div class="content" v-if="route.name == 'PDO3'">
    <PDO3 />
  </div>
  <div class="content" v-if="route.name == 'PDO11'">
    <PDO11 />
  </div>
  <div class="content" v-if="route.name == 'PDO3Rapat'">
    <PDO3Rapat />
  </div>
  <div class="content" v-if="route.name == 'PDO2'">
    <PDO2 />
  </div>
  <div class="content" v-if="route.name == 'PDO1'">
    <PDO1 />
  </div>
  <div class="content" v-if="route.name == 'PDO7'">
    <PDO7 />
  </div>
  <div class="content" v-if="route.name == 'IPP'">
    <IPP />
  </div>
  <div class="content" v-if="route.name == 'GAP'">
    <GAP />
  </div>
  <div class="content" v-if="route.name == 'PDOIOS'">
    <PDOIOS />
  </div>
  <div class="content" v-if="route.name == 'CEMP'">
    <CEMP />
  </div>
  <div class="content" v-if="route.name == 'RKLRPL'">
    <RKLRPL />
  </div>
  <div class="content" v-if="route.name == 'Sampel'">
    <Sampel />
  </div>
  <div class="content" v-if="route.name == 'Regulasi'">
    <Regulasi />
  </div>
  <div class="content" v-if="route.name == 'ProsesRegulasi'">
    <ProsesRegulasi />
  </div>
  <div class="content" v-if="route.name == 'DaftarRegulasi'">
    <DaftarRegulasi />
  </div>
  <div class="content" v-if="route.name == 'KategoriData'">
    <KategoriData />
  </div>
  <div class="content" v-if="route.name == 'ProsesKategoriData'">
    <ProsesKategoriData />
  </div>
  <div class="content" v-if="route.name == 'AduanMasyarakat'">
    <AduanMasyarakat />
  </div>
  <div class="content" v-if="route.name == 'ProsesAduanMasyarakat'">
    <ProsesAduanMasyarakat />
  </div>
  <div class="content" v-if="route.name == 'TindaklanjutAduanMasyarakat'">
    <TindaklanjutAduanMasyarakat />
  </div>
  <div class="content" v-if="route.name == 'LayerPeta'">
    <LayerPeta />
  </div>
  <div class="content" v-if="route.name == 'ProsesLayerPeta'">
    <ProsesLayerPeta />
  </div>
  <div class="content" v-if="route.name == 'Berita'">
    <Berita />
  </div>
  <div class="content" v-if="route.name == 'ProsesBerita'">
    <ProsesBerita />
  </div>
  <div class="content" v-if="route.name == 'Galeri'">
    <Galeri />
  </div>
  <div class="content" v-if="route.name == 'ProsesGaleri'">
    <ProsesGaleri />
  </div>
  <div class="content" v-if="route.name == 'DetailGaleri'">
    <DetailGaleri />
  </div>
  <div class="content" v-if="route.name == 'Dokumen'">
    <Dokumen />
  </div>
  <div class="content" v-if="route.name == 'ProsesDokumen'">
    <ProsesDokumen />
  </div>
  <div class="content" v-if="route.name == 'DetailDokumen'">
    <DetailDokumen />
  </div>
  <div class="content" v-if="route.name == 'GIS'">
    <GIS />
  </div>
  <div class="content" v-if="route.name == 'DaftarKonten'">
    <DaftarKonten />
  </div>
  <div class="content" v-if="route.name == 'ImportExcel'">
    <ImportExcel />
  </div>
  <div class="content" v-if="route.name == 'FAQ'">
    <FAQ />
  </div>
  <div class="content" v-if="route.name == 'DataDokumen'">
    <DataDokumen />
  </div>
  <div class="content" v-if="route.name == 'Environment'">
    <Environment />
  </div>
  <div class="content" v-if="route.name == 'ProsesEnvironment'">
    <ProsesEnvironment />
  </div>
  <div class="content" v-if="route.name == 'Social'">
    <Social />
  </div>
  <div class="content" v-if="route.name == 'ProsesSocial'">
    <ProsesSocial />
  </div>
  <div class="content" v-if="route.name == 'Konsultan'">
    <Konsultan />
  </div>
  <div class="content" v-if="route.name == 'ProsesKurvaSKonsultan'">
    <ProsesKurvaSKonsultan />
  </div>
  <div class="content" v-if="route.name == 'KendalaTindakLanjutKonsultan'">
    <KendalaTindakLanjutKonsultan />
  </div>
  <div class="content" v-if="route.name == 'Finance'">
    <Finance />
  </div>
  <div class="content" v-if="route.name == 'ProsesDIPA'">
    <ProsesDIPA />
  </div>
  <div class="content" v-if="route.name == 'ProsesSPM'">
    <ProsesSPM />
  </div>
  <div class="content" v-if="route.name == 'UserAbsensi'">
    <UserAbsensi />
  </div>
  <div class="content" v-if="route.name == 'ProsesUserAbsensi'">
    <ProsesUserAbsensi />
  </div>
  <div class="content" v-if="route.name == 'DataAbsensi'">
    <DataAbsensi />
  </div>
  <div class="content" v-if="route.name == 'ProsesDataAbsensi'">
    <ProsesDataAbsensi />
  </div>
  <div class="content" v-if="route.name == 'ProsesDetailAbsensi'">
    <ProsesDetailAbsensi />
  </div>
  <div class="content" v-if="route.name == 'PengaturanIzin'">
    <PengaturanIzin />
  </div>
  <div class="content" v-if="route.name == 'ProsesPengaturanIzin'">
    <ProsesPengaturanIzin />
  </div>
  <div class="content" v-if="route.name == 'LokasiAbsensi'">
    <LokasiAbsensi />
  </div>
  <div class="content" v-if="route.name == 'ProsesLokasiAbsensi'">
    <ProsesLokasiAbsensi />
  </div>
  <div class="content" v-if="route.name == 'HariLibur'">
    <HariLibur />
  </div>
  <div class="content" v-if="route.name == 'ProsesHariLibur'">
    <ProsesHariLibur />
  </div>
  <div class="content" v-if="route.name == 'Aksi'">
    <Aksi />
  </div>
  <div class="content" v-if="route.name == 'Google'">
    <Google />
  </div>
  <div class="content" v-if="route.name == 'Izin'">
    <Izin />
  </div>
  <div class="content" v-if="route.name == 'DL'">
    <DL />
  </div>
  <div class="content" v-if="route.name == 'ProfilAksi'">
    <ProfilAksi />
  </div>
  <div class="content" v-if="route.name == 'Statistik'">
    <Statistik />
  </div>
  <div class="content" v-if="route.name == 'SettingMenu'">
    <SettingMenu />
  </div>
</template>

<script>
import Beranda from './components/views/Publik/Beranda.vue';
import Login from './components/views/Publik/Login.vue';
import AksiLogin from './components/views/Publik/AksiLogin.vue';
import KontakKami from './components/views/Publik/KontakKami.vue';
import MasukanSaran from './components/views/Publik/MasukanSaran.vue';
import DaftarProgramBudgeting from './components/views/Publik/DaftarProgramBudgeting.vue';
import DaftarStatus from './components/views/Publik/DaftarStatus.vue';
import DaftarFinance from './components/views/Publik/DaftarFinance.vue';
import DaftarPDOIOS from './components/views/Publik/DaftarPDOIOS.vue';
import DaftarQuickStatus from './components/views/Publik/DaftarQuickStatus.vue';
import DaftarAduan from './components/views/Publik/DaftarAduan.vue';
import DaftarTimPelaksana from './components/views/Publik/DaftarTimPelaksana.vue';
import DaftarAgenda from './components/views/Publik/DaftarAgenda.vue';
import DaftarMonev from './components/views/Publik/DaftarMonev.vue';
import Aduan from './components/views/Publik/Aduan.vue';
import FAQ from './components/views/Publik/FAQ.vue';
import CariAduan from './components/views/Publik/CariAduan.vue';
import Dashboard from './components/views/Dashboard/Dashboard.vue';
import Aksi from './components/views/Aksi/Aksi.vue';
import Google from './components/views/Aksi/Google.vue';
import Izin from './components/views/Aksi/Izin.vue';
import DL from './components/views/Aksi/DL.vue';
import ProfilAksi from './components/views/Aksi/ProfilAksi.vue';
import Statistik from './components/views/Aksi/Statistik.vue';
import Slider from './components/views/Backoffice/Slider/Slider.vue';
import ProsesSlider from './components/views/Backoffice/Slider/ProsesSlider.vue';
import Kategori from './components/views/Backoffice/Kategori/Kategori.vue';
import ProsesKategori from './components/views/Backoffice/Kategori/ProsesKategori.vue';
import SubKategori from './components/views/Backoffice/SubKategori/SubKategori.vue';
import ProsesSubKategori from './components/views/Backoffice/SubKategori/ProsesSubKategori.vue';
import UnitKategori from './components/views/Backoffice/UnitKategori/UnitKategori.vue';
import ProsesUnitKategori from './components/views/Backoffice/UnitKategori/ProsesUnitKategori.vue';
import InfoBeranda from './components/views/Backoffice/InfoBeranda/InfoBeranda.vue';
import ProsesInfoBeranda from './components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue';
import Konten from './components/views/Backoffice/Konten/Konten.vue';
import ProsesKonten from './components/views/Backoffice/Konten/ProsesKonten.vue';
import User from './components/views/Backoffice/User/User.vue';
import ProsesUser from './components/views/Backoffice/User/ProsesUser.vue';
import TimPelaksana from './components/views/Backoffice/TimPelaksana/TimPelaksana.vue';
import ProsesTimPelaksana from './components/views/Backoffice/TimPelaksana/ProsesTimPelaksana.vue';
import Inbox from './components/views/Backoffice/Inbox/Inbox.vue';
import ProsesInbox from './components/views/Backoffice/Inbox/ProsesInbox.vue';
import Kalendar from './components/views/Backoffice/Kalendar/Kalendar.vue';
import ProsesKalendar from './components/views/Backoffice/Kalendar/ProsesKalendar.vue';
import ViewKalendar from './components/views/Backoffice/Kalendar/ViewKalendar.vue';
import Monev from './components/views/Backoffice/Monev/Monev.vue';
import ProsesMonev from './components/views/Backoffice/Monev/ProsesMonev.vue';
import ProsesPDOMonev from './components/views/Backoffice/Monev/ProsesPDOMonev.vue';
import ProsesKurvaS from './components/views/Backoffice/Monev/ProsesKurvaS.vue';
import KendalaTindakLanjut from './components/views/Backoffice/Monev/KendalaTindakLanjut.vue';
import PDO3 from './components/views/Backoffice/Monev/PDO3.vue';
import PDO11 from './components/views/Backoffice/Monev/PDO11.vue';
import PDO3Rapat from './components/views/Backoffice/Monev/PDO3Rapat.vue';
import PDO2 from './components/views/Backoffice/Monev/PDO2.vue';
import PDO1 from './components/views/Backoffice/Monev/PDO1.vue';
import PDO7 from './components/views/Backoffice/Monev/PDO7.vue';
import Environment from './components/views/Backoffice/Environment/Environment.vue';
import ProsesEnvironment from './components/views/Backoffice/Environment/ProsesEnvironment.vue';
import Social from './components/views/Backoffice/Social/Social.vue';
import ProsesSocial from './components/views/Backoffice/Social/ProsesSocial.vue';
import IPP from './components/views/Backoffice/IPP/IPP.vue';
import ImportExcel from './components/views/ImportExcel/ImportExcel.vue';
import GAP from './components/views/Backoffice/GAP/GAP.vue';
import PDOIOS from './components/views/Backoffice/PDOIOS/PDOIOS.vue';
import CEMP from './components/views/Backoffice/CEMP/CEMP.vue';
import RKLRPL from './components/views/Backoffice/RKLRPL/RKLRPL.vue';
import Sampel from './components/views/Backoffice/Sampel/Sampel.vue';
import Regulasi from './components/views/Backoffice/Regulasi/Regulasi.vue';
import ProsesRegulasi from './components/views/Backoffice/Regulasi/ProsesRegulasi.vue';
import DaftarRegulasi from './components/views/Publik/DaftarRegulasi.vue';
import AduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/AduanMasyarakat.vue';
import ProsesAduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/ProsesAduanMasyarakat.vue';
import TindaklanjutAduanMasyarakat from './components/views/Backoffice/AduanMasyarakat/TindaklanjutAduanMasyarakat.vue';
import KategoriData from './components/views/Backoffice/KategoriData/KategoriData.vue';
import ProsesKategoriData from './components/views/Backoffice/KategoriData/ProsesKategoriData.vue';
import LayerPeta from './components/views/Backoffice/LayerPeta/LayerPeta.vue';
import ProsesLayerPeta from './components/views/Backoffice/LayerPeta/ProsesLayerPeta.vue';
import GIS from './components/views/Publik/GIS.vue';
import DaftarKonten from './components/views/Publik/DaftarKonten.vue';
import DaftarKegiatan from './components/views/Publik/DaftarKegiatan.vue';
import DaftarBerita from './components/views/Publik/DaftarBerita.vue';
import Berita from './components/views/Backoffice/Berita/Berita.vue';
import ProsesBerita from './components/views/Backoffice/Berita/ProsesBerita.vue';
import DaftarAlbum from './components/views/Publik/DaftarAlbum.vue';
import DaftarGaleri from './components/views/Publik/DaftarGaleri.vue';
import Galeri from './components/views/Backoffice/Galeri/Galeri.vue';
import ProsesGaleri from './components/views/Backoffice/Galeri/ProsesGaleri.vue';
import DetailGaleri from './components/views/Backoffice/Galeri/DetailGaleri.vue';
import Dokumen from './components/views/Backoffice/Dokumen/Dokumen.vue';
import ProsesDokumen from './components/views/Backoffice/Dokumen/ProsesDokumen.vue';
import DetailDokumen from './components/views/Backoffice/Dokumen/DetailDokumen.vue';
import DaftarAlbumDokumen from './components/views/Publik/DaftarAlbumDokumen.vue';
import DaftarAlbumDocumen from './components/views/Publik/DaftarAlbumDocumen.vue';
import DaftarGaleriDokumen from './components/views/Publik/DaftarGaleriDokumen.vue';
import DataDokumen from './components/views/Backoffice/NewDokumen/Dokumen.vue';
import Konsultan from './components/views/Backoffice/Konsultan/Monev.vue';
import ProsesKurvaSKonsultan from './components/views/Backoffice/Konsultan/ProsesKurvaS.vue';
import KendalaTindakLanjutKonsultan from './components/views/Backoffice/Konsultan/KendalaTindakLanjut.vue';
import Finance from './components/views/Backoffice/Finance/Finance.vue';
import ProsesDIPA from './components/views/Backoffice/Finance/ProsesDIPA.vue';
import ProsesSPM from './components/views/Backoffice/Finance/ProsesSPM.vue';
import UserAbsensi from './components/views/Backoffice/Absensi/UserAbsensi.vue';
import ProsesUserAbsensi from './components/views/Backoffice/Absensi/ProsesUserAbsensi.vue';
import DataAbsensi from './components/views/Backoffice/Absensi/DataAbsensi.vue';
import ProsesDataAbsensi from './components/views/Backoffice/Absensi/ProsesDataAbsensi.vue';
import ProsesDetailAbsensi from './components/views/Backoffice/Absensi/ProsesDetailAbsensi.vue';
import PengaturanIzin from './components/views/Backoffice/PengaturanIzin/PengaturanIzin.vue';
import ProsesPengaturanIzin from './components/views/Backoffice/PengaturanIzin/ProsesPengaturanIzin.vue';
import LokasiAbsensi from './components/views/Backoffice/LokasiAbsensi/LokasiAbsensi.vue';
import ProsesLokasiAbsensi from './components/views/Backoffice/LokasiAbsensi/ProsesLokasiAbsensi.vue';
import HariLibur from './components/views/Backoffice/HariLibur/HariLibur.vue';
import ProsesHariLibur from './components/views/Backoffice/HariLibur/ProsesHariLibur.vue';
import SettingMenu from './components/views/Backoffice/SettingMenu/SettingMenu.vue';

import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  components: {
    Beranda, Login, KontakKami, MasukanSaran, Dashboard, GIS, DaftarKonten, DaftarProgramBudgeting
    , DaftarStatus, DaftarFinance, DaftarMonev, DaftarPDOIOS, DaftarQuickStatus, Aduan, DaftarAduan, CariAduan
    , Slider, ProsesSlider, InfoBeranda, ProsesInfoBeranda, Konten, ProsesKonten
    , User, ProsesUser, KategoriData, ProsesKategoriData, Monev, ProsesMonev, ProsesPDOMonev, ProsesKurvaS, CEMP, Sampel
    , Regulasi, ProsesRegulasi, DaftarRegulasi, Kategori, ProsesKategori, KendalaTindakLanjut, PDO3, PDO11, PDO2, PDO1
    , PDO7
    , SubKategori, ProsesSubKategori, UnitKategori, ProsesUnitKategori
    , LayerPeta, ProsesLayerPeta, RKLRPL, IPP, GAP, PDOIOS, ImportExcel
    , DaftarKegiatan, Berita, ProsesBerita, DaftarBerita, Galeri, ProsesGaleri, DetailGaleri
    , DaftarAlbum, DaftarGaleri, Dokumen, ProsesDokumen, DetailDokumen
    , DaftarAlbumDokumen, DaftarGaleriDokumen, AduanMasyarakat, ProsesAduanMasyarakat, TindaklanjutAduanMasyarakat
    , FAQ, DataDokumen, DaftarAlbumDocumen, TimPelaksana, ProsesTimPelaksana, DaftarTimPelaksana, Kalendar, ProsesKalendar
    , ViewKalendar, DaftarAgenda, Inbox, ProsesInbox, Environment, ProsesEnvironment, Konsultan, ProsesKurvaSKonsultan
    , KendalaTindakLanjutKonsultan, Social, ProsesSocial, Finance, ProsesDIPA, ProsesSPM, UserAbsensi, ProsesUserAbsensi
    , HariLibur, ProsesHariLibur, AksiLogin, Aksi, Google, Izin, DL, ProfilAksi, Statistik, PengaturanIzin, ProsesPengaturanIzin
    , LokasiAbsensi, ProsesLokasiAbsensi, DataAbsensi, ProsesDataAbsensi, ProsesDetailAbsensi,SettingMenu, PDO3Rapat
  },
  mounted() {
    document.title = "MIS NUFReP";
  },
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  }
}
</script>

<style></style>
